
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.198 11.294l6.037-6.206-.355-.382-5.86 5.977-2.841-2.907-.355.399 3.018 3.119z"}}),_c('path',{attrs:{"d":"M8 16a7.949 7.949 0 005.657-2.343A7.946 7.946 0 0016 8a7.946 7.946 0 00-2.343-5.657A7.947 7.947 0 008 0a7.948 7.948 0 00-5.657 2.343A7.947 7.947 0 000 8c0 2.137.832 4.146 2.343 5.657A7.947 7.947 0 008 16zM2.697 2.697A7.45 7.45 0 018 .5c2.004 0 3.887.78 5.304 2.196A7.45 7.45 0 0115.5 8c0 2.003-.78 3.887-2.196 5.303A7.45 7.45 0 018 15.5a7.452 7.452 0 01-5.304-2.197A7.45 7.45 0 01.5 8a7.45 7.45 0 012.197-5.303z"}})])
          )
        }
      }
    